import styled from "styled-components";

import { Text } from "/component/base";
import { layout } from "/styles";

export const Title = styled(Text).attrs({
  variant: "title1",
  element: "h2",
  color: "textTitle",
})(layout.marginVertical("expanded"));

export const ContentContainer = styled.div(({ theme }) => ({
  ...layout.flexVertical,
  [theme.media.max.mobile]: {
    flexDirection: "column",
    marginTop: 20,
    marginBottom: 20,
  },
}));

export const ButtonContainer = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  "> *": {
    flex: 1,
  },
  marginTop: 40,
  [theme.media.max.tabletPortrait]: {
    ...layout.flexVertical,
    ...layout.spacedChildrenHorizontal("none")({ theme }),
    "& > *": {
      padding: theme.spacing[12],
      width: "100%",
      marginTop: theme.spacing.condensed,
    },
  },
}));
